"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _isNull = _interopRequireDefault(require("lodash/isNull"));
var _isUndefined = _interopRequireDefault(require("lodash/isUndefined"));
var _DebugManager = _interopRequireDefault(require("../utils/DebugManager"));
var _RUMUtil = _interopRequireDefault(require("../utils/RUMUtil"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var dmInstance = _DebugManager["default"].dmInstance;
var MAX_CONNECTION_CHECKS = 60;
var PING = 'ping';
var PONG = 'pong';
var PING_INTERVAL = 30000; // Send ping every 30 seconds
var PONG_TIMEOUT = 5000; // Wait max of 5 seconds for pong response
var WSEvent = exports["default"] = /*#__PURE__*/function () {
  function WSEvent(dataHandler, errorHandler) {
    var _this = this;
    _classCallCheck(this, WSEvent);
    _defineProperty(this, "event", function (event) {
      var _JSON$parse = JSON.parse(event.data),
        id = _JSON$parse.id,
        serverError = _JSON$parse.serverError,
        action = _JSON$parse.action,
        _JSON$parse$component = _JSON$parse.componentEvent,
        _JSON$parse$component2 = _JSON$parse$component === void 0 ? {} : _JSON$parse$component,
        compEventId = _JSON$parse$component2.id,
        payload = _JSON$parse$component2.payload;
      if (!(0, _isUndefined["default"])(serverError)) {
        console.warn("[WsEvent] WS post failed:");
        var error = new Error('[WsEvent] WS post failed');
        _RUMUtil["default"].addError(error, {
          serverError: serverError
        });
        return;
      }
      if (action === PONG) {
        _this.handlePong();
        return;
      }
      _this.dataHandler([{
        payload: payload
      }]);
      dmInstance.logMessage([_DebugManager["default"].debugLevel.WS], "[WSEvent] Processed component event: ".concat(compEventId));
      dmInstance.logMessage([_DebugManager["default"].debugLevel.WS], "[WSEvent] Last component event processed: ".concat(id));
      _this.lastEventProcessed = id;
      _this.unprocessedEvents["delete"](compEventId);
    });
    _defineProperty(this, "error", function (event) {
      var msg = '[WsEvent] Error from websocket';
      console.error(msg, event);
      _this.errorHandler(event, msg);
    });
    _defineProperty(this, "close", function () {
      var closeEvent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      // We have seen the case where the websocket just closes without firing the error handler,
      // so we need to log the code and reason to decipher what happened.
      var socketReadyState = _this.socket ? _this.socket.readyState : '';
      var msg = "[WsEvent] Websocket closed with code: (".concat(closeEvent.code, ") reason: ").concat(closeEvent.reason, ", readyState: ").concat(socketReadyState);
      console.warn(msg);
      var eventData = _this.getLastUnprocessedEventData();
      _this.errorHandler(eventData && JSON.parse(eventData), msg);
    });
    /**
     * Will gracefully close the socket on a control room clean action
     */
    _defineProperty(this, "cleanup", function () {
      if (_this.socket && _this.socket.readyState === 1) {
        _this.socket.close();
        console.warn('[WsEvent] Socket successfully closed');
      }
      _this.socket = null;
      _this.stopPingPong();
      _this.checkConnectionCleanup();
    });
    _defineProperty(this, "postEvent", function (metadata, data) {
      var inBand = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var componentEventId = _this.reluctantlyGenerateUniqueId();
      dmInstance.logMessage([_DebugManager["default"].debugLevel.WS], "[WSEvent] Received new event ".concat(componentEventId), data);

      // users can potentially start performing actions in the control room before the socket has connected,
      // so we need a check for a connected and open socket
      if (!_this.isConnectionReady()) {
        dmInstance.logMessage([_DebugManager["default"].debugLevel.WS], "[WSEvent] Connection not fully established yet. Adding ".concat(componentEventId, " to queue."));
        _this.unprocessedEvents.set(componentEventId, {
          metadata: metadata,
          data: data,
          inBand: inBand
        });
        if (!_this.checkConnectionInterval) {
          _this.checkConnectionInterval = setInterval(_this.checkConnection, 1000);
        }
        return;
      }
      _this.unprocessedEvents.set(componentEventId, {
        metadata: metadata,
        data: data,
        inBand: inBand
      });
      var postObj = _this.generatePostData(componentEventId, metadata, data, inBand);
      if (postObj) {
        _this.send(postObj);
      }
    });
    _defineProperty(this, "isConnectionReady", function () {
      return !(0, _isNull["default"])(_this.socket) && _this.socket.readyState === 1;
    });
    /*
      Called on an interval to see if connection status has changed.
      If MAX_CONNECTION_CHECKS has exceeded will evoke error handler
      to failover to HTTP.
    */
    _defineProperty(this, "checkConnection", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var msg;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this.numOfChecks++;
            if (_this.isConnectionReady()) {
              _context.next = 5;
              break;
            }
            if (_this.numOfChecks > MAX_CONNECTION_CHECKS) {
              dmInstance.logMessage([_DebugManager["default"].debugLevel.WS], "[WSEvent] Exceeded time limit to process events via websocket.");
              msg = '[WsEvent] Could not process received events via websocket.';
              _this.errorHandler({
                metadata: metadata,
                data: data
              }, msg);
            }
            _context.next = 8;
            break;
          case 5:
            _this.checkConnectionCleanup();
            _context.next = 8;
            return _this.handleUnprocessedEvents();
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    /*
      Process all events that were received prior to a fully
      established websocket connection.
    */
    _defineProperty(this, "processUnprocessedEvents", function () {
      return new Promise(function (resolve) {
        _toConsumableArray(_this.unprocessedEvents).map(function (_ref2) {
          var _ref3 = _slicedToArray(_ref2, 2),
            key = _ref3[0],
            _ref3$ = _ref3[1],
            metadata = _ref3$.metadata,
            data = _ref3$.data,
            inBand = _ref3$.inBand;
          dmInstance.logMessage([_DebugManager["default"].debugLevel.WS], "[WSEvent] Processing unprocessed component event via websocket: id: ".concat(key, " data: ").concat(data));
          var postObj = _this.generatePostData(key, metadata, data, inBand);
          if (postObj) {
            _this.send(postObj);
          }
        });
        resolve();
      });
    });
    _defineProperty(this, "getUnprocessedEvents", function () {
      return _this.unprocessedEvents;
    });
    _defineProperty(this, "emptyUnprocessedEvents", function () {
      _this.unprocessedEvents = new Map();
    });
    _defineProperty(this, "getLastUnprocessedEventData", function () {
      var lastEvent = _toConsumableArray(_this.unprocessedEvents)[_this.unprocessedEvents.size - 1];
      var _ref4 = lastEvent ? lastEvent[1] : {},
        data = _ref4.data;
      return data;
    });
    _defineProperty(this, "getLastEventProcessed", function () {
      return _this.lastEventProcessed;
    });
    _defineProperty(this, "reluctantlyGenerateUniqueId", function () {
      return "".concat(Date.now(), "-").concat(Math.floor(Math.random() * 100000));
    });
    this.socket = null;
    this.dataHandler = dataHandler || this.missingHandler;
    this.errorHandler = errorHandler || this.missingHandler;
    this.unprocessedEvents = new Map();
    this.lastEventProcessed = '';
    this.numOfChecks = 0;
    this.pingInterval = null;
    this.pongTimeout = null;
    this.lastPongReceived = null;
  }
  return _createClass(WSEvent, [{
    key: "missingHandler",
    value: function missingHandler() {
      throw new Error('Missing handler function!');
    }
  }, {
    key: "initiate",
    value: function initiate(accountId, eventId, wsComponentEventHost) {
      var _this2 = this;
      console.log("[WsEvent] Initiating WS event manager...");
      return new Promise(function (resolve, reject) {
        try {
          _this2.socket = new WebSocket("".concat(wsComponentEventHost, "/websocket/account/").concat(accountId, "/event/").concat(eventId, "/componentEvent/producer"));
          _this2.socket.addEventListener('open', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
            return _regeneratorRuntime().wrap(function _callee2$(_context2) {
              while (1) switch (_context2.prev = _context2.next) {
                case 0:
                  console.warn('[WsEvent] WS connection has been successfully established.');
                  _this2.checkConnectionCleanup();
                  _context2.next = 4;
                  return _this2.handleUnprocessedEvents();
                case 4:
                  _this2.startPingPong();
                  resolve(true);
                case 6:
                case "end":
                  return _context2.stop();
              }
            }, _callee2);
          })));
          _this2.socket.addEventListener('message', _this2.event);
          _this2.socket.addEventListener('close', _this2.close);
          _this2.socket.addEventListener('error', function (error) {
            _this2.error(error);
            reject(error);
          });
        } catch (e) {
          var msg = '[WsEvent] Error initializing WebSocket: ';
          console.warn(msg, e);
          _RUMUtil["default"].addError(e);
          reject(e);
        }
      });
    }
  }, {
    key: "startPingPong",
    value: function startPingPong() {
      var _this3 = this;
      this.lastPongReceived = Date.now();
      this.pingInterval = setInterval(function () {
        if (_this3.isConnectionReady()) {
          _this3.sendPing();
        }
      }, PING_INTERVAL);
    }
  }, {
    key: "stopPingPong",
    value: function stopPingPong() {
      if (this.pingInterval) {
        clearInterval(this.pingInterval);
        this.pingInterval = null;
      }
      if (this.pongTimeout) {
        clearTimeout(this.pongTimeout);
        this.pongTimeout = null;
      }
    }
  }, {
    key: "sendPing",
    value: function sendPing() {
      var _this4 = this;
      try {
        this.socket.send(JSON.stringify({
          action: PING,
          timestamp: Date.now()
        }));
        if (!this.pongTimeout) {
          this.pongTimeout = setTimeout(function () {
            _this4.handlePongTimeout();
          }, PONG_TIMEOUT);
        }
      } catch (err) {
        console.warn('[WsEvent] Error sending ping:', err);
        _RUMUtil["default"].addError("[WsEvent] Error sending ping: ".concat(err));
      }
    }
  }, {
    key: "handlePongTimeout",
    value: function handlePongTimeout() {
      var timeSinceLastPong = Date.now() - this.lastPongReceived;
      console.warn("[WsEvent] No pong response received for ".concat(timeSinceLastPong, "ms"));

      // Close the socket and trigger error handler
      var error = new Error('WebSocket unresponsive - no pong received');
      this.socket.close(1000, 'Connection unresponsive');
      this.errorHandler(error, '[WsEvent] Connection unresponsive - no pong received');
    }
  }, {
    key: "handlePong",
    value: function handlePong() {
      this.lastPongReceived = Date.now();
      if (this.pongTimeout) {
        clearTimeout(this.pongTimeout);
        this.pongTimeout = null;
      }
    }
  }, {
    key: "send",
    value: function send(postObj) {
      dmInstance.logMessage([_DebugManager["default"].debugLevel.WS], "[WSEvent] Sending event: ".concat(postObj.params.componentEventId, "."));
      try {
        this.socket.send(JSON.stringify(postObj));
      } catch (err) {
        console.warn('[WsEvent] Error in postEvent: ', err);
        _RUMUtil["default"].addError(err);
      }
    }
  }, {
    key: "checkConnectionCleanup",
    value:
    /*
      Websocket connection has been fully established and we're ready to 
      send events through the websocket.  
      Need to clear up the interval.
    */
    function checkConnectionCleanup() {
      if (this.checkConnectionInterval) {
        clearInterval(this.checkConnectionInterval);
        this.checkConnectionInterval = null;
        this.numOfChecks = 0;
      }
    }
  }, {
    key: "handleUnprocessedEvents",
    value: function () {
      var _handleUnprocessedEvents = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!(this.unprocessedEvents.size > 0)) {
                _context3.next = 4;
                break;
              }
              dmInstance.logMessage([_DebugManager["default"].debugLevel.WS], "[WSEvent] Begin processing unprocessed events via websocket.");
              _context3.next = 4;
              return this.processUnprocessedEvents();
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function handleUnprocessedEvents() {
        return _handleUnprocessedEvents.apply(this, arguments);
      }
      return handleUnprocessedEvents;
    }()
  }, {
    key: "generatePostData",
    value: function generatePostData(componentEventId, metadata, data, inBand) {
      var destinationType = metadata.destinationType,
        eventId = metadata.eventId,
        accountId = metadata.accountId;
      if ((0, _isUndefined["default"])(destinationType) || (0, _isUndefined["default"])(eventId) || (0, _isUndefined["default"])(accountId)) {
        console.error('[WsEvent] metadata missing! Unable to process event.', data);
        return;
      }
      var destination = destinationType === 'audience' ? 'viewer' : destinationType;
      return {
        eventId: eventId,
        accountId: accountId,
        action: 'postComponentEvent',
        params: {
          destination: destination.toUpperCase(),
          componentEventId: componentEventId,
          inBand: inBand
        },
        payload: JSON.parse(data)
      };
    }
  }]);
}();